import { PAYMENT_TYPES } from "./payment.constants";

export const TIMESHEET_STATUS = {
  BILLABLE: "conflict_solve",
};
export const TIMESHEET_DETAILED_STATUS = {
  TO_COMPLETE: "to_complete",
  EXTRA_COMPLETED: "extra_completed",
  ETAB_COMPLETED: "etab_completed",
  AGREED: "agreed",
  FORCE_AGREED: "force_agreed",
  CONFLICTED: "conflicted",
  CONFLICT_RESOLVED_FOR_EXTRA: "conflict_resolved_for_extra",
  CONFLICT_RESOLVED_FOR_ETAB: "conflict_resolved_for_etab",
  CONFLICT_RESOLVED_BY_US: "conflict_resolved_by_us",
  BILLABLE: "billable",
  EXTRA_NO_SHOW: "extra_no_show",
};

export const BILLABLE_SESSION_VIEWS = {
  LIST: "list",
  SHIFT: "shift",
};

export const BILLABLE_SESSION_TYPES = {
  EXTRA: "extra",
  ETAB: "etab",
};

export const BILLING_SESSIONS_INVOICE_STATUS = {
  BILLABLE: {
    label: "BO.DASHBOARD.BILLING_SESSION.@BILLABLE",
    color: "primary",
    code: "invoice_creation",
  },
  BILLABLE_IN_PROGRESS: {
    label: "BO.DASHBOARD.BILLING_SESSION.@BILLABLE_IN_PROGRESS",
    color: "primary",
    code: "invoice_creation_in_progress",
  },
  BILLABLE_FAILED: {
    label: "BO.DASHBOARD.BILLING_SESSION.@BILLABLE_FAILED",
    color: "extra-dark-red",
    code: "invoice_creation_failed",
  },
  TO_PAY: {
    label: "BO.DASHBOARD.BILLING_SESSION.@TO_PAY",
    color: "extra-light-green",
    code: "payable",
  },
  INCOMING_PAYMENT: {
    label: "BO.DASHBOARD.BILLING_SESSION.@INCOMING_PAYMENT",
    color: "extra-dark-green",
    code: "to_be_paid",
  },
  PAYMENT_FAILED: {
    label: "BO.DASHBOARD.BILLING_SESSION.@PAYMENT_FAIL",
    color: "extra-dark-red",
    code: "payment_failed",
  },
  TO_VALIDATE: {
    label: "BO.DASHBOARD.BILLING_SESSION.@TO_VALIDATE",
    color: "extra-blue-2",
    code: "invoice_validation_pending",
  },
  VALIDATION_FAILED: {
    label: "BO.DASHBOARD.BILLING_SESSION.@VALIDATION_FAILED",
    color: "extra-dark-red",
    code: "invoice_validation_ko",
  },
  TRANSFERABLE: {
    label: "BO.DASHBOARD.BILLING_SESSION.@TRANSFERABLE",
    color: "extra-blue-2",
    code: "transferable",
  },
  TRANSFERT_FAILED: {
    label: "BO.DASHBOARD.BILLING_SESSION.@TRANSFERT_FAIL",
    color: "extra-dark-red",
    code: "transfer_failed",
  },
  PAYED: {
    label: "BO.DASHBOARD.BILLING_SESSION.@FINISHED",
    color: "extra-green",
    code: "payment_done",
  },
};

export const BILLING_SESSION_PAYMENT_TYPE = {
  BANK_TRANSFER: "bank_transfer",
  DEBIT: "sepa_debit",
};

export const BILLING_SESSIONS_ROW_PER_PAGE = 300;

export const BILLABLE_SHIFTS_PLATFORMS = {
  STRIPE: "stripe",
  SELLSY: "sellsy",
  LEGACY: "legacy", // @Deprecated
};

export const BILLABLE_SHIFTS_STATUS = {
  TO_BILL: {
    code: "to_bill",
    label: "BO.DASHBOARD.BILLABLE_SHIFTS.@TO_BILL",
    color: "grey",
  },
  BILLED: {
    code: "fully_billed",
    label: "BO.DASHBOARD.BILLABLE_SHIFTS.@BILLED",
    color: "extra-green",
  },
  ETAB_TO_BILL: {
    code: "etab_billed",
    label: "BO.DASHBOARD.BILLABLE_SHIFTS.@EXTRA_TO_BILL",
    color: "accent",
  },
  EXTRA_TO_BILL: {
    code: "extra_billed",
    label: "BO.DASHBOARD.BILLABLE_SHIFTS.@ETAB_TO_BILL",
    color: "accent",
  },
};

export const BILLING_ARIA_STATUS_TYPES = {
  BILLING_SESSION: "billing-session-status",
  ARIA: "status-aria",
  STRIPE: "status-stripe",
  PAYMENT_TYPES: "payment-types",
};

export const BILLING_ARIA_SEARCH_TYPES = [
  { label: "BO.DASHBOARD.BILLING_ARIA.@SEARCH_BY_BILLING_SESSION_ID", value: "billing-id" },
  { label: "BO.DASHBOARD.BILLING_ARIA.@SEARCH_BY_BO_ID", value: "etab-id" },
  { label: "BO.DASHBOARD.BILLING_ARIA.@SEARCH_BY_STRIPE_ID", value: "stripe-id" },
  { label: "BO.DASHBOARD.BILLING_ARIA.@SEARCH_BY_ETAB_NAME", value: "etab-name" },
  { label: "BO.DASHBOARD.BILLING_ARIA.@SEARCH_BY_ETAB_SIREN", value: "etab-siren" },
  { label: "BO.DASHBOARD.BILLING_ARIA.@SEARCH_BY_INVOICE_ID", value: "invoice-id" },
];

export const BILLING_ARIA_SORT_OPTIONS = [
  { label: "BO.DASHBOARD.BILLING_ARIA.@SORT_BY_DATE", value: "date" },
  { label: "BO.DASHBOARD.BILLING_ARIA.@SORT_BY_AMOUNT", value: "amount" },
];

export const BO_DATE_FORMAT = "YYYY-MM-DD HH:mm";

export const IDENTIFIER_TYPE = {
  ETAB: "etab",
  EXTRA: "extra",
  CANDIDATE: "candidate",
};

// ADMIN FOLDER

export const ADMIN_FOLDER_STATUS = {
  PENDING_INTERNAL_VERIFICATION: {
    label: "BO.DASHBOARD.ADMIN_FOLDER.@PENDING_INTERNAL_VALIDATION",
    code: "pending_internal_verification",
    color: "primary",
  },
  PENDING_INTERNAL_RE_VERIFICATION: {
    label: "BO.DASHBOARD.ADMIN_FOLDER.@PENDING_INTERNAL_RE_VALIDATION",
    code: "pending_internal_re_verification",
    color: "grey",
  },
  PENDING: {
    label: "BO.DASHBOARD.ADMIN_FOLDER.@PENDING",
    code: "pending",
    color: "warning",
  },
  VERIFIED: {
    label: "BO.DASHBOARD.ADMIN_FOLDER.@VALIDATED",
    code: "verified",
    color: "extra-green",
  },
  REFUSED: {
    label: "BO.DASHBOARD.ADMIN_FOLDER.@REFUSED",
    code: "refused",
    color: "extra-red",
  },
};

export const ADMIN_FOLDER_ALERT = {
  EXPIRING_DOCUMENT_SOON: "EXPIRING_DOCUMENT_SOON",
  EXPIRED_DOCUMENT: "EXPIRED_DOCUMENT",
  DUPLICATE_IBAN: "DUPLICATE_IBAN",
  KYC_UNVERIFIED: "KYC_UNVERIFIED",
  KYC_PENDING: "KYC_PENDING",
  KYC_VERIFIED: "KYC_VERIFIED",
  MISSING_KYC_FIELD: "MISSING_KYC_FIELD",
};

export const MIME_TYPES = {
  PDF: "application/pdf",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
  PNG: "image/png",
};

export const ADMIN_FOLDER_DOCUMENTS = {
  IDENTITY: "IDENTITE",
  IDENTITY_VERSO: "IDENTITE_VERSO",
  AE: "INSEE",
  RIB: "RIB",
  RESIDENCE: "RESIDENCE",
  RESIDENCE_PERMIT: "RESIDENCE_PERMIT",
  RESIDENCE_PERMIT_VERSO: "RESIDENCE_PERMIT_VERSO",
  RESIDENCE_PERMIT_TYPE: "TITRE_SEJOUR",
  TEMPORARY_RESIDENCE_PERMIT_TYPE: "TITRE_SEJOUR_TEMPORAIRE",
};

export const ADMIN_FOLDER_DOCUMENTS_SLUG = {
  IDENTITY: "document-identity-types",
  RESIDENCE_PERMIT: "residence-permit-types",
};

export const ADMIN_FOLDER_EXPIRE_CODE = {
  EXPIRED: "expired",
  WILL_EXPIRE_SOON: "will_expire_soon",
};

export const REFUSAL_REASON_OTHER = "OTHER_REASON";

export const WALLET_AMOUNT_OCCURENCES_PER_PAGES = 10;

export const KYC_STATUS = {
  NON_EXISTENT: "nonexistent",
  WAITING_FOR_ACCEPTANCE: "waiting_for_acceptance",
  PENDING: "pending",
  UNVERIFIED: "unverified",
  VERIFIED: "verified",
};
